import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import {PTSans_base64} from "./fontBase64";
import {grandlineLogo} from "./grandlineLogo";
import store from "../store";
import print from 'print-js'

let elemCanvasWithImg = null;
// let paramMaterials = null;

const createPdf = async function (paramMaterials, photos) {
    console.log(Object.keys(photos).length);
    if (paramMaterials === null) {
        alert("Нет данных для формирования отчета!");
        return;
    }
    let finalY = 0;
    let yOffset = function (value) {
        finalY += value;
        return finalY
    };

    let doc = new jsPDF({putOnlyUsedFonts: true});
    doc.addFileToVFS('PTSans.ttf', PTSans_base64);
    doc.addFont('PTSans.ttf', 'PTSans', 'normal');
    doc.setFont("PTSans");

    let dataText = {
        number: 1,
        cost: 0,
        area: 0
    };

    let tableRows = [];
    for (let material of paramMaterials) {
        let tableRow = [];
        let measureUnits = '';
        if (material.type === 'wall') {
            measureUnits = ' м²'
        } else if (material.type === 'additional') {
            measureUnits = ' пог. м'
        }
        // tableRow.push(material.img);
        tableRow.push(material.name);
        tableRow.push(material.price.toString().replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' '));
        tableRows.push(tableRow);
        dataText.cost += material.cost;
        dataText.area += material.area;
    }

    doc.addImage(
        grandlineLogo,
        'PNG', 15, 13, 60, 11);
    doc.setFontSize(10);
    // doc.text('© 1996 – 2020 Компания «Выбор»\n' +
    //     'Один из крупнейших производителей\n' +
    //     'тротуарной плитки и элементов\n' +
    //     'благоустройства в стране', 50, 15, null, null);

    // doc.text('Отдел продаж', 115, 15, null, null);
    // doc.setFontSize(11);
    // doc.setTextColor('#d83336');
    // doc.text('8 (800) 770-77-36', 115, 20, null, null);
    // doc.setTextColor('#000000');
    // doc.setFontSize(10);
    // doc.text('Москва', 115, 25, null, null);

    doc.text('Горячая линия (бесплатно)', 155, 15, null, null);
    doc.setFontSize(11);
    doc.setTextColor('#d83336');
    doc.text('8 (800) 770-77-36', 155, 20, null, null);
    doc.setTextColor('#828282');
    doc.setFontSize(10);
    doc.text('info@grandline.ru', 155, 25, null, null);

    doc.setFontSize(16);
    doc.setTextColor('#d83336');
    doc.text("Товары:", 15, yOffset(40));
    doc.setTextColor('#000000');

    // doc.text("Площадь территории для работ: " + dataText.area.toFixed(2) + " м²", 20, yOffset(10));
    // doc.text("Материалы: ", 20, yOffset(10));
    ////////////////////////////////////
    doc.autoTable({
        theme: 'grid',
        startY: yOffset(10),
        headStyles: {halign: 'left', fontStyle: "PTSans", fillColor: "#f3f3f3", textColor: "#404040"},
        styles: {font: "PTSans", halign: 'left', lineColor: "#E6E6E6", lineWidth: "0.3"},
        head: [["Наименование", "Цена за ед. ₽"]],
        bodyStyles: {fillColor: null},
        body: tableRows
    });
    finalY = doc.previousAutoTable.finalY;
    ///////////////////////////////////////
    // doc.setFontSize(10);
    // doc.text("Общая стоимость:", 15, yOffset(10));
    // doc.setTextColor('#d83336');
    // doc.setFontSize(11);
    // doc.text(dataText.cost.toFixed(2).toString().replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ') + " ₽", 45, yOffset(0));
    doc.setFontSize(10);
    doc.setTextColor('#828282');
    doc.text("Данные получены на сайте https://3d.grandline.ru/", 108, yOffset(10));
    doc.setTextColor('#d83336');
    ////////////////////////////////////////////
    // if (store.state.userInfo.phone) {
    //     doc.text("Телефон менеджера: " + store.state.userInfo.phone, 195, yOffset(0) + 5, 'right');
    // }
    // ///////////////////////////////
    // doc.setFontSize(16);
    // doc.text("Изображение: ", 15, yOffset(10));
    // doc.setTextColor('#000000');
    // ///////////////////////////////////////
    //

    let arrPromise = [];
        if (photos[0].length !== null) {

            if (finalY === 0)
                doc.addPage();

            let uselessPromise = new Promise((resolve) => {
                setTimeout(() => {
                    resolve()
                }, 100)
            });
            await uselessPromise;
            const promise = new Promise(async function (resolve, reject) {
                let img = new Image()
                img.src = store.getters[`projectConfiguration/GENERATE_URL`](photos[0]);
                img.onload = () => {
                    doc.addImage(img, 'JPEG', 15, yOffset(10), 180, Math.round((img.height*180)/img.width));
                    img = null
                    finalY = 0;
                    resolve();
                }
            });
            arrPromise.push(promise);
            await store.dispatch('IN_PROGRESS', promise);
        }

    await Promise.all(arrPromise);
    ///////////////////////////////////////
    return doc;
};

// export const getResultPDF_Blob = (materials) => {
//     return createPdf(materials).output('blob');
// }

export const loadResultPDF = function (materials, photos) {
    return new Promise(function (resolve, reject) {
        createPdf(materials, photos).then(doc => {
            doc.save('Result.pdf');
            resolve();
        }).catch((err) => {
            reject(err)
        });
    });
};

export const printResultPDF = function (materials, photos) {
    return new Promise(function (resolve, reject) {
        createPdf(materials, photos).then(doc => {
            // let document = doc.output('datauri')
            var string = doc.output('datauristring');
            var iframe = "<iframe width='100%' height='100%' src='" + string + "'></iframe>"
            var x = window.open();
            x.document.open();
            x.document.write(iframe);
            x.document.close();
    //         // print({printable: document, type: 'pdf', base64: true})
            resolve();
        }).catch((err) => {
            reject(err)
        });
    });
};
